import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n)

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'ja', // 追加
  messages: {
    ja : require('../lang/ja.json'),
    en : require('../lang/en.json')
  }
})



// WEBPACK FOOTER //
// ./src/lang.js